export const FETCH_BRANDS_CONTEXT__SUCCESS = 'FETCH_BRANDS_CONTEXT__SUCCESS';

export function fetchBrandsContextSuccess(brandId, context) {
  return { type: FETCH_BRANDS_CONTEXT__SUCCESS, brandId, context };
}

